module.exports = __webpack_public_path__ + "static/img/5.bbe3149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/5.png
// module id = bxyG
// module chunks = 94